<pageheader [entity]="headerEntity"></pageheader>
<div *ngIf="listView" class="top-btns">
    <div class="table-outer">
        <grid [entities]="menu" [actionExclude]="['feedback','column']"  [checkboxCol]="true" [entityColumns]="menuColumns" [selectionField]="'Menu_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add '" [downloadEntityCaption]="'Download '" (downloadEntities)="onExcelExport()"
            (addEntity)="addMenu($event)" (editEntity)="editEntity($event)" (refreshEntities)="refreshMenu($event)"
            (deleteEntity)="deleteMenu($event)" (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip"></grid>
    </div>
</div>
<div *ngIf="!listView">
    <div class="report top-btns">
        <div class="form-caption-nav">
              {{ formCaption }}
        </div>
        <nav class="navbar-expand-md navbar-white navbar-form bg-light  mt-2">
            <ul class="navbar-nav justify-content-end">
              
                <li class="nav-item">
                    <a class="nav-link" (click)="clearMenu()"><i class="bi bi-slash-circle"></i>Clear</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="revertChanges()"><i class="bi bi-arrow-clockwise"></i>Revert
                        Changes</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="gotoBack()"><i class="bi bi-arrow-left-circle"></i>Go Back</a>
                </li>
            </ul>
        </nav>
        <div class="form-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <textbox [caption]="'Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                            [fieldName]="'Menu_Name'" [(ngModel)]="entity.Menu_Name" ngDefaultControl></textbox>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <dropdown [caption]="'Parent Menu'" [data]="menu.data" [textField]="'Menu_Name'"
                            [valueField]="'Menu_Id'" [formData]="entity" [fieldName]="'Menu_Id'"
                            [(ngModel)]="entity.Menu_Id" ngDefaultControl [selectedItem]="selectedParentMenu" >
                        </dropdown>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <textbox [caption]="'Url'" [formData]="entity" [fieldName]="'Menu_URL'" [maxlength]="200"
                            [mandatory]="true" [(ngModel)]="entity.Menu_URL" ngDefaultControl>
                        </textbox>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <dropdown [caption]="'Module'" [data]="module" [textField]="'Module_Name'"
                            [valueField]="'Module_Id'" [formData]="entity" [fieldName]="'Module_Id'"
                            [(ngModel)]="entity.Module_Id" ngDefaultControl [selectedItem]="selectedmodule"
                            [filterable]="true" (filterChanged)="getAllModules($event)"></dropdown>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <textbox [caption]="'Order'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                            [fieldName]="'Order_Id'" [(ngModel)]="entity.Order_Id" (keypress)="numberOnly($event)"
                            ngDefaultControl></textbox>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'"
                [disabled]="saveDisabled" [type]="'button'"></btn>
            </div>
        </div> 
    </div>
</div>

<kendo-excelexport [data]="menu.data" [collapsible]="true" fileName="Menu.xlsx" #excelexport>
    <kendo-excelexport-column field="Menu_Name" title="Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Menu_Parent_Id" title="Parent Id" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Menu_Parent_Name" title="Parent Menu" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Menu_URL" title="URL" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Module_Id" title="Module Id" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Order_Id" title="Order Id" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>